<template>
  <div class="app-container">
    <list ref="list" @setDetails="setDetails">
      <template slot="toolbar-right">
        <el-button  type="success" plain @click="onExport" >导出</el-button>
        <el-button type="primary" @click="unchecks">批量弃审</el-button>
        <el-button type="primary" @click="create" icon="el-icon-plus">添加</el-button>
        <el-button type="primary" @click="checks">批量审核</el-button>
      </template>
      <template slot="column" v-if="$permission.canWrite() || $route.query.canWrite">
        <el-table-column label="操作" fixed="right" align="center" width="155">
          <template slot-scope="{ row }">
        <el-button type="text" @click="copy(row)" v-if="row.Status!= 4">复制</el-button>
            <el-button type="text" v-if="row.Status!=2&&row.Status!= 4" @click="editById(row.DocId)">编辑</el-button>
            <el-button type="text" @click="check(row)">{{row.Status==0&&row.Status!= 4?'审核':'查看'}}</el-button>
            <el-button type="text" v-if="row.Status!=2&&row.Status!= 4" @click="delRows(row.DocId)">删除</el-button>
          </template>
        </el-table-column>
      </template>
    </list>
    <div class="list-head" style="margin-top: 10px;">
      <span>订单详情</span>
      <div class="list-detail">
        <span>订单号：{{row.DocNo||'-'}}</span>
        <span>业务员：{{row.ClerkName||'-'}}</span>
        <span>备注：{{row.Remark||'-'}}</span>
        <span>订单金额：{{ Math.floor(row.Amount*100)/100||'-' }}</span>
      </div>
    </div>
    <div class="thinScroll" :style="'px;overflow-y:auto;width:100%'">
      <el-row class="mb0">
        <el-table :data="Details" border style="width:100%;">
          <el-table-column type="index" label="序号" width="50" align="center"></el-table-column>
          <el-table-column prop="GoodsCode" label="条码" align="center" min-width="100" />
          <el-table-column prop="WarehouseName" label="仓库" align="center" />
          <el-table-column prop="GoodsName" label="商品名称" align="center" />
          <el-table-column prop="Model" label="规格型号" align="center" />
          <el-table-column prop="UnitName" label="单位" align="center" />
          <el-table-column prop="Quantity" label="数量" width="90" align="center" />
          <el-table-column prop="ExistQuantity" label="现存量" align="center" />
          <el-table-column prop="AvailableQuantity" label="可用量" align="center" />
          <el-table-column prop="Offer" label="报价" align="center">
            <template slot-scope="{ row }">{{$commonJs.toThousands(row.Offer)}}</template>
          </el-table-column>
          <el-table-column prop="Discount" label="折扣%" width="90" align="center" />
          <el-table-column prop="Price" label="单价" width="90" align="center">
            <template slot-scope="{ row }">{{$commonJs.toThousands(row.Price)}}</template>
          </el-table-column>
          <el-table-column prop="TaxRate" label="税率/%" width="90" align="center" />
          <el-table-column prop="TaxAmount" label="税额" width="90" align="center">
            <template slot-scope="{ row }">{{$commonJs.toThousands(row.TaxAmount)}}</template>
          </el-table-column>
          <el-table-column prop="Amount" label="含税金额" width="90" align="center">
            <template slot-scope="{ row }">{{$commonJs.toThousands(row.Amount)}}</template>
          </el-table-column>
          <el-table-column prop="NoTaxAmount" label="不含税金额" width="90" align="center">
            <template slot-scope="{ row }">{{$commonJs.toThousands(row.NoTaxAmount)}}</template>
          </el-table-column>
          <el-table-column prop="Remark" label="备注" width="150px" />
          <el-table-column prop="BactNo" label="批次号" width="100px" />
          <el-table-column prop="ProductionDate" label="生产日期" />
          <el-table-column prop="ExpirationDate" label="失效日期" />
        </el-table>
      </el-row>
    </div>
    <edit-dialog ref="editDialog" @close-saved="reload" />
    <details-dialog ref="detailsDialog" @close-saved="reload" />
  </div>
</template>
<script>
import curdMixins from "@/mixins/curd";
import list from "@/components/sales/business/bill/list";
import editDialog from "@/components/sales/business/bill/editDialog";
import detailsDialog from "@/components/sales/business/bill/detailsDialog";

export default {
  name: "bill",
  mixins: [curdMixins],
  components: {
    list,
    editDialog,
    detailsDialog
  },
  data() {
    return {
      api: require("@/api/sale/saDoc").default,
      isMB: this.$store.state.isMB,
      Details: [],
      row: {},
    };
  },
  // mounted() {
  //   if(this.$route.params.SourcePage == '库存成本台账') {
  //     this.$refs.detailsDialog.openDetailsById(this.$route.params.OrderId)
  //   }
  // },
  // activated(){
  //   if(this.$route.params.SourcePage == '库存成本台账') {
  //     this.$refs.detailsDialog.openDetailsById(this.$route.params.OrderId)
  //   }
  // },
  methods: {
    checks() {
      let rows = this.$refs.list.getCheckedRows();
      if(rows.length==0){
        this.$message.error("请勾选操作项");
        return;
      }
      this.api.examinelist(rows.map((e) => e.DocId)).then((res) => {
        if (res.Code == 0) {
          this.$message.success(res.Msg);
          this.$refs.list.reload();
        } else {
          this.$message.error(res.Msg);
        }
      });
    },
    unchecks() {
      let rows = this.$refs.list.getCheckedRows();
      if(rows.length==0){
        this.$message.error("请勾选操作项");
        return;
      }
      this.api.cancelExamineList(rows.map((e) => e.DocId)).then((res) => {
        if (res.Code == 0) {
          this.$message.success(res.Msg);
          this.$refs.list.reload();
        } else {
          this.$message.error(res.Msg);
        }
      });
    },
    setDetails(list, row) {
      this.Details = list;
      this.row = row;
    },
    print(row) {
      let newpage = this.$router.resolve({
        path: "/qualityPrint?sid=" + row.DocId,
      });
      window.open(newpage.href, "_blank");
    },
    check(row) {
      // sessionStorage.setItem("check", "1");
      // this.editById(row.DocId);
      if(row.Status === 2){
        this.$refs.detailsDialog.setReadonly(true)
      }else{
        this.$refs.detailsDialog.setReadonly(false)
      }
      this.$refs.detailsDialog.openDetailsById(row.DocId)
    },
    delRows(id) {
      this.$confirm("确认删除数据吗？", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      })
        .then(() => {
          this.api.delete(id).then((res) => {
            if (res.Code == 0) {
              this.$message.success("删除成功");
              this.$refs.list.reload();
            } else {
              this.$message.error(res.Msg);
            }
          });
        })
        .catch(() => {});
    },
    copy(row){
      this.api.info(row.DocId).then((res)=>{
        if(res.Code==0){          
         
          res.Data.Goods.forEach(x => {
            x.DocId=0;
            x.DocGoodsId=0;
            x.T=0;
          });
          res.Data.Receipts.forEach(x => {
            x.DocId=0;
          });
          let data={...res.Data,DocId:0,OutStatus:0,ReceiptStatus:0,Status:0,InvoiceStatus:0}
          this.$refs.editDialog.openCreate(data);
        }

      })
    }, 
    onExport() {
      this.$confirm("是否导出数据？", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      })
        .then(() => {
          this.$refs.list.onExport();
        })
        .catch(() => {});
    },
  },
};
</script>